:host {
  display: contents;
}

.br-table-cell {
  min-width: 0;
  color: var(--color-light);
  padding: var(--br-table-density) var(--table-row-size);
  border-right: calc(var(--br-table-divider-base-width, 0px) * var(--br-table-column-divider-factor, 0))
    var(--br-table-divider-style, solid) var(--border-color);
  border-bottom: calc(var(--br-table-divider-base-width, 0px) * var(--br-table-row-divider-factor, 0))
    var(--br-table-divider-style, solid) var(--border-color);
  background-color: var(--background-light);
  font-size: var(--font-size-scale-base);
  font-weight: var(--font-weight-medium);
}

.br-table-cell-content {
  display: flex;
  align-items: var(--br-table-vertical-alignment);
  justify-content: var(--br-table-horizontal-alignment);
  min-width: 0;
  height: 100%;
}

.br-table-cell-truncate {
  min-width: 0;
  max-width: 100%;
  overflow: var(--br-table-cell-overflow);
  text-overflow: var(--br-table-cell-text-overflow);
  white-space: var(--br-table-cell-white-space);
  word-break: break-all;
}

:host([data-last-column]) .br-table-cell {
  border-right: none;
}

:host([data-last-row]) .br-table-cell {
  border-bottom: none;
}
